import { TableCellTypes } from '@carboledger/ui';
import { makeSerialCell } from '@/components/common';
import { MATERIAL_COLUMNS, MATERIAL_SORT_FIELDS } from './materials.constants';

const canSort = (id) => Boolean(MATERIAL_SORT_FIELDS[id]);

export const buildMaterialsColumns = (t, { serialOffset = 0 } = {}) =>
  [
    {
      id: MATERIAL_COLUMNS.serialNo,
      header: t('FIELD_SERIAL_NO'),
      type: TableCellTypes.custom,
      width: 80,
      cell: makeSerialCell(serialOffset),
    },
    {
      id: MATERIAL_COLUMNS.materialName,
      header: t('FIELD_MATERIAL_NAME'),
      type: TableCellTypes.text,
      width: 200,
      pinnable: true,
    },
    {
      id: MATERIAL_COLUMNS.materialCode,
      header: t('FIELD_MATERIAL_ID'),
      type: TableCellTypes.text,
      width: 160,
    },
    {
      id: MATERIAL_COLUMNS.materialType,
      header: t('FIELD_MATERIAL_TYPE'),
      type: TableCellTypes.text,
      width: 140,
    },
    {
      id: MATERIAL_COLUMNS.certificateType,
      header: t('FIELD_CERTIFICATION_TYPE'),
      type: TableCellTypes.text,
      width: 160,
    },
    {
      id: MATERIAL_COLUMNS.declarationUnit,
      header: t('FIELD_DECLARATION_UNIT'),
      type: TableCellTypes.text,
      width: 140,
    },
    {
      id: MATERIAL_COLUMNS.workingUnit,
      header: t('FIELD_WORKING_UNIT'),
      type: TableCellTypes.text,
      width: 140,
    },
    {
      id: MATERIAL_COLUMNS.conversionFactor,
      header: t('FIELD_CONVERSION_FACTOR'),
      type: TableCellTypes.text,
      width: 160,
    },
    {
      id: MATERIAL_COLUMNS.energyContent,
      header: t('FIELD_ENERGY_CONTENT_PER_UNIT'),
      type: TableCellTypes.text,
      width: 160,
    },
  ].map((column) => ({ ...column, sortable: canSort(column.id) }));
